import { AutoMap } from "@automapper/classes"
import { EFlaskType } from "./enums/flask-type"
import { BaseDOM } from "./base.dom"

export class Flacon extends BaseDOM<Flacon> {
    @AutoMap()
    Code!: string
    @AutoMap()
    Type!: EFlaskType
    @AutoMap()
    Barcode!: string

}